export enum PageKey {
  toc,
  onboarding,
  contactInfo,
  personalInfo,
  incomeInfo,
  cardInfo,
  bankInfo,
  review,
  landing,
  addressInfo,
  approved,
  denied,
  pending,
  disclosures,
  cartReview,
  esign,
  paymentSigning,
  addCard,
  checkoutCard,
  verifyItsYou,
  none,
  useMyApproval,
  needHelp,
  applyOnlyApproval,
  wirelessPlan,
}
